import apiSlice from "./ApiSlice";

const productManagementApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllProductManagementData: builder.query({
      providesTags: ["product"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/product",
          method: "POST",
          body,
        };
      },
    }),
    getAllProductManagement: builder.query({
      providesTags: ["product"],
      query: () => {
        return {
          url: "/product",
          method: "GET",
        };
      },
    }),

    // delete delivery date
    deleteProductManagementById: builder.mutation({
      invalidatesTags: ["product"],
      query: (id: any) => ({
        url: `/product/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addProductManagement: builder.mutation({
      invalidatesTags: ["product"],
      query: (body) => ({
        url: `/product/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getProductManagementById: builder.query({
      providesTags: ["product"],
      query: (id: string) => {
        return {
          url: `/product/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateProductManagementById: builder.mutation({
      invalidatesTags: ["product"],
      query: ({ body, id }) => ({
        url: `/product/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusProductManagementById: builder.mutation({
      invalidatesTags: ["product"],
      query: ({ body, id }) => ({
        url: `/product/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
    //sync products by api
    createSynkProductManagementByAPI: builder.mutation({
      invalidatesTags: ["product"],
      query: () => ({
        url: `/product/sync-products`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetAllProductManagementDataQuery,
  useDeleteProductManagementByIdMutation,
  useAddProductManagementMutation,
  useGetProductManagementByIdQuery,
  useUpdateProductManagementByIdMutation,
  useChangeStatusProductManagementByIdMutation,
  useCreateSynkProductManagementByAPIMutation,
  useGetAllProductManagementQuery
} = productManagementApi;
